import React from 'react';

import * as S from './styles.sc';

type Node = {
  value: React.ReactNode;
  list?: Node[];
};

type Props = {
  data: {
    list: Node[];
  };
};

export const List: React.FC<React.PropsWithChildren<{ data: Node }>> = ({
  data,
}) => {
  return (
    <li>
      {data.value}
      {data.list?.length && (
        <ol>
          {data.list.map((node, index) => {
            return <List key={index} data={node} />;
          })}
        </ol>
      )}
    </li>
  );
};

export const NestedNumberedList: React.FC<React.PropsWithChildren<Props>> = ({
  data,
}) => {
  return (
    <S.NestedNumberedListContainer>
      {data.list?.length && (
        <ol>
          {data.list.map((node, index) => {
            return <List key={index} data={node} />;
          })}
        </ol>
      )}
    </S.NestedNumberedListContainer>
  );
};
